import LazyLoad from 'vanilla-lazyload'

new LazyLoad({ elements_selector: '.lazy' })
